import React, { useEffect, useRef, useState } from 'react'
import { CaretDown, MagnifyingGlass, X } from '@phosphor-icons/react'

import InputText from '../input/input-text'

export default function Select(props) {
    const {
        classNameContainer = 'grid gap-1 relative',
        classNameContainerAdditional = '',
        classNameInput = 'flex gap-2 items-center h-10 overflow-auto px-3 w-full',
        classNameInputAdditional = '',
        classNameInputContainer = 'bg-white border-[1px] border-border cursor-pointer flex items-center gap-2 overflow-hidden rounded-lg w-full',
        classNameInputContainerAdditional = '',
        classNameInputSearch = 'bg-white px-3 py-2 rounded-lg w-full',
        classNameInputSearchAdditional = '',
        classNameLabel = 'caption2',
        classNameLabelAdditional = '',
        label = '',
        leftSpan = null,
        multiple = false,
        onChange = undefined,
        options = [],
        placeholder = '',
        required = false,
        searchable = false,
        value = undefined,
    } = props

    const [getOpenList, setOpenList] = useState(false)
    const [getValueSearch, setValueSearch] = useState('')
    const [getValueSelected, setValueSelected] = useState([])

    const refContainer = useRef()

    // ✅ keep internal selected in sync with external value prop
    useEffect(() => {
        if (multiple) {
            setValueSelected(Array.isArray(value) ? value : [])
        } else {
            setValueSelected(value ? [value] : [])
        }
    }, [value, multiple])

    useEffect(() => {
        const handler = (event) => CloseListOption(event)
        document.addEventListener('mouseup', handler)
        return () => document.removeEventListener('mouseup', handler)
    }, [getOpenList])

    const CloseListOption = (e) => {
        if (getOpenList) {
            if (refContainer?.current && !refContainer?.current?.contains(e?.target)) {
                setOpenList(false)
                setValueSearch('')
            }
        }
    }

    const RemoveAllItem = (e) => {
        e?.stopPropagation?.()
        setValueSelected([])
        onChange && onChange(multiple ? [] : null)
    }

    const RemoveItem = (index, e) => {
        e?.stopPropagation?.()

        if (!multiple) {
            setValueSelected([])
            onChange && onChange(null)
            return
        }

        let selected = getValueSelected ? [...getValueSelected] : []
        selected.splice(index, 1)
        setValueSelected(selected)
        onChange && onChange(selected)
    }

    const SelectItem = (item) => {
        let selected = getValueSelected ? [...getValueSelected] : []

        if (multiple) {
            const check = selected.findIndex((data) => data?.value === item?.value)
            if (check < 0 && item) selected.push(item)
            else selected.splice(check, 1)

            setValueSelected(selected)
            onChange && onChange(selected)
        } else {
            setValueSelected(item ? [item] : [])
            setOpenList(false)
            onChange && onChange(item || null)
        }

        setValueSearch('')
    }

    const dataListOption = options?.filter((item) =>
        item?.label?.toString()?.toLowerCase()?.includes(getValueSearch?.toLowerCase())
    )

    // ✅ what to show in the input area
    const selectedLabels = getValueSelected?.map((x) => x?.label).filter(Boolean) || []
    const hasSelection = selectedLabels.length > 0

    return (
        <div className={[classNameContainer, classNameContainerAdditional].filter(Boolean).join(' ')}>
            {label ? (
                <p className={[classNameLabel, classNameLabelAdditional].filter(Boolean).join(' ')}>
                    {label} {required ? <span className="text-danger">*</span> : null}
                </p>
            ) : null}

            <div ref={refContainer} className="relative">
                <div
                    className={[classNameInputContainer, classNameInputContainerAdditional].filter(Boolean).join(' ')}
                    onClick={() => setOpenList((prev) => !prev)}
                >
                    {leftSpan ? <div className="pl-3 py-2 relative">{leftSpan}</div> : null}

                    <div className={[classNameInput, classNameInputAdditional].filter(Boolean).join(' ')}>
                        {hasSelection ? (
                            multiple ? (
                                <div className="flex flex-wrap gap-2" onClick={(e) => e.stopPropagation()}>
                                    {getValueSelected.map((item, idx) => (
                                        <div
                                            key={item?.value ?? idx}
                                            className="bg-border cursor-default flex gap-2 items-center px-2 py-[2px] relative rounded-md"
                                        >
                                            <button type="button" onClick={(e) => RemoveItem(idx, e)}>
                                                <X color="#5f5f5f" size={12} weight="bold" />
                                            </button>
                                            <p className="body2">{item?.label}</p>
                                        </div>
                                    ))}
                                    {getValueSelected.length > 1 ? (
                                        <button
                                            type="button"
                                            className="caption2 text-gray-500 underline"
                                            onClick={RemoveAllItem}
                                        >
                                            Clear
                                        </button>
                                    ) : null}
                                </div>
                            ) : (
                                <p className="body2">{selectedLabels[0]}</p>
                            )
                        ) : (
                            <p className="caption2 text-gray-400">{placeholder || label}</p>
                        )}
                    </div>

                    <button type="button" className="border-l px-3 py-2" onClick={(e) => e.stopPropagation()}>
                        <CaretDown color="#5f5f5f" size={20} />
                    </button>
                </div>

                {getOpenList ? (
                    <ul className="absolute bg-white border border-border rounded-lg shadow-md top-[calc(100%+4px)] w-full z-[1]">
                        {(searchable && options?.length > 0) ? (
                            <div className="border-b p-2 relative">
                                <InputText
                                    classNameInput={classNameInputSearch}
                                    classNameInputAdditional={classNameInputSearchAdditional}
                                    leftSpan={<MagnifyingGlass color="#5f5f5f" size={24} />}
                                    onChange={(e) => setValueSearch(e?.target?.value)}
                                    placeholder={placeholder}
                                    required={true}
                                    value={getValueSearch}
                                />
                            </div>
                        ) : null}

                        {dataListOption?.length > 0 ? (
                            <div className="p-2 relative">
                                {dataListOption.map((item, index) => (
                                    <li
                                        key={item?.value ?? index}
                                        className="cursor-pointer px-3 py-2 rounded-md hover:bg-light"
                                        onClick={() => SelectItem(item)}   // ✅ this was the bug
                                    >
                                        {item?.label}
                                    </li>
                                ))}
                            </div>
                        ) : (
                            <li className="px-3 py-2 text-center">Tidak ada data</li>
                        )}
                    </ul>
                ) : null}
            </div>
        </div>
    )
}
